import React from 'react';
import { func, shape, object } from 'prop-types';
import createWithModals from '../../hooks/useModal';
import Modal from '../Modal';
import s from './Footer.module.scss';

const Footer = ({ mainTexts, footerText, modals: { regularModal } }) => {
  const showModal = ({ title, text }) => {
    regularModal && regularModal.show({ title, text });
  };

  return (
    <div className={s.footerWrap}>
      <p className={s.footerText}>{footerText.title}</p>
      <div className={s.footerActions}>
        <p
          onClick={() =>
            showModal({
              title: footerText.terms,
              text: [
                mainTexts.bigFooterText,
                mainTexts.bigFooterText1,
                mainTexts.bigFooterText2,
              ],
            })
          }
        >
          {footerText.terms}
        </p>
        <span>|</span>
        <p
          onClick={() =>
            showModal({
              title: footerText.privacy,
              text: [
                mainTexts.bigFooterText,
                mainTexts.bigFooterText1,
                mainTexts.bigFooterText2,
              ],
            })
          }
        >
          {footerText.privacy}
        </p>
        <span>|</span>
        <p
          onClick={() =>
            showModal({
              title: footerText.contact.title,
              text: [footerText.contact.text],
            })
          }
        >
          {footerText.contact.title}
        </p>
      </div>
    </div>
  );
};

Footer.propTypes = {
  mainTexts: object,
  footerText: object,
  modals: shape({
    regularModal: shape({
      show: func,
    }),
  }),
};

export default createWithModals({
  regularModal: Modal,
})(Footer);
